import { render } from "./branch-tree-node.vue?vue&type=template&id=5c29543c"
import script from "./branch-tree-node.vue?vue&type=script&lang=js"
export * from "./branch-tree-node.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__